'use client'

import { RefreshCwIcon } from 'lucide-react'

import { describeLotRecomputeProgress } from '~/app/accounting/lot-recompute'
import { LotRecomputeState } from '~/app/accounting/useLotRecompute'
import { Button } from '~/components/component-library'

export const RecomputeLotsButton = ({
  recompute,
}: {
  recompute: LotRecomputeState
}) => {
  const { job, isRunning, isStarting, hasPollingFailed } = recompute
  // Once polling has given up the queue state is unknown, so reopen the button
  // and let the server's dedup decide.
  const isDisabled = isRunning && !hasPollingFailed

  return (
    <Button
      variant="secondary"
      prefix={<RefreshCwIcon />}
      isLoading={isStarting}
      isDisabled={isDisabled}
      disabledReason={
        isDisabled && job ? describeLotRecomputeProgress(job) : undefined
      }
      onClick={() => recompute.recompute()}
    >
      {isDisabled ? 'Recomputing lots' : 'Recompute lots'}
    </Button>
  )
}
